import { nextTick, reactive, ref, unref, watch } from 'vue'

export default function useIntersectionobserver(observerConfig){
    const observer = ref(new IntersectionObserver(observerConfig))
    const intersect = ref(null)

    watch(() => observerConfig, () => {
        //If we already have an observer disconnect it before starting the new one
        if(observer.value instanceof IntersectionObserver){
            observer.value.disconnect()
        }
        observer.value = new IntersectionObserver(observerConfig)
    })

    const onStartObserving = async (element = null) => {
        await nextTick()

        observer.value.observe(
            element !== null
                ? unref(element)
                : intersect.value
        )
    }

    const onStopObserving = async (element = null) => {
        await nextTick()

        element = unref(element)
        if(element !== null){
            observer.value.unobserve(element)
        } else {
            //If the element has been removed from the dom first it won't be set
            //so we should just remove the entire observer
            observer.value.disconnect()
        }
    }

    return {
        intersect        : intersect,
        onStartObserving : onStartObserving,
        onStopObserving  : onStopObserving
    }
}